<p-dialog
  [(visible)]="displayModal"
  [modal]="true"
  [style]="{ width: '50vw' }"
  [draggable]="false"
  [resizable]="true"
  styleClass="order-dialog">
  <ng-template pTemplate="header">
    <div class="header-modal pb-4 has-border w-100 d-flex align-items-center">
      <h2 class="me-2">Vendor Invoice Journal Detail</h2>
    </div>
  </ng-template>

  <div *ngFor="let item of vendorInvoiceJournalDetail">
    <a class="link" [href]="item.DocumentURL" target="_blank">{{
      item.DocumentURL
    }}</a>
  </div>

  <ng-template pTemplate="footer">
    <div class="d-flex pt-2 justify-content-end">
      <button
        type="button"
        (click)="closeModalDialog()"
        class="btn btn-secondary me-3">
        Cancel
      </button>
    </div>
  </ng-template>
</p-dialog>
